import React from 'react';
import { Portfolio } from './components';
import { LanguageProvider } from './language/LanguageContext';
import LanguageSwitcher from './language/LanguageSwitcher';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Portfolio />
        <LanguageSwitcher />
      </div>
    </LanguageProvider>
  );
}

export default App;